export const CATALOGUE = {
  racine: 'Accueil',
  titleProduit: 'Liste des produits',
  titleProduitEcranNum: 'Liste des produits Ecran Numérique',
  titleProduitNonCom: 'Liste des produits non commercialisables',
  audience: 'Audiences',
  marques: 'Enseignes/Marques',
  societeSelect: 'Société :',
  dateVisu: 'Date de visualisation :',
  labelCopy: 'Copie de ',
  edition: {
    reseau: 'Réseau',
    reseauSansCarto: 'Réseau sans carto',
    unitaire: 'Faces unitaires',
    diaporama: 'Diaporama',
    face: 'Fiche face',
    ecranNumerique: 'Ecran numérique',
  },
  popUpPreventionCopy: {
    message: 'Etes-vous sûr de vouloir dupliquer ce produit ?',
    success: 'Produit dupliqué avec succès.',
  },
  popUpSuppressionFace: {
    message: 'Etes-vous sûr de vouloir supprimer cette face ?',
    messageMulti: 'Etes-vous sûr de vouloir supprimer ces faces ?',
    success: 'La face a été supprimée avec succès.',
    successMulti: 'Les faces ont été supprimées avec succès.',
  },
  popUpModicationDateFace: {
    messageDateDebut: 'Etes-vous sûr de vouloir modifier la date de début de cette face ?',
    messageDateFin: 'Etes-vous sûr de vouloir modifier la date de fin de cette face ?',
    messageDateDebutMulti: 'Etes-vous sûr de vouloir modifier la date de début de ces faces ?',
    messageDateFinMulti: 'Etes-vous sûr de vouloir modifier la date de fin de ces faces ?',
  },
  dispo: {
    anyDispo: 'Veuillez enregistrer votre produit pour accéder aux disponibilités',
    selectDispoReseau: 'Cliquez sur une case ci-dessous pour en modifier les disponibilités.',
    numberFace: '{numberFace} faces',
    objectif: 'Objectif :',
  },
  popUpDispoReseau: {
    gestion: 'Gestion des disponibilités',
    depart: 'Jour de départ',
    faceDispo: 'Nb faces dispo',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    cancel: 'Annuler',
    dispoAdd: 'Les disponibilités ont bien été modifiées',
    objectif: 'Objectif par face',
  },
  popUpDispoFace: {
    gestion: 'Gestion des disponibilités',
    disponibilite: 'Disponibilité',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    commentaire: 'Commentaire',
    cancel: 'Annuler',
    disponibleStatus: 'Disponible',
    indisponibleStatus: 'Indisponible',
    dispoAdd: 'Les disponibilités ont bien été modifiées',
    spotTotal: 'Nb spots total',
    spotBailleur: 'Nb de spots bailleurs',
    spotReseau: 'Nb de spots réseaux',
    spotLc: 'Nb de spots LC',
    nbSpot: 'Nb de spots',
  },
  archivage: {
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitFaceArchiver: 'Produit face archivé avec succès',
    produitReseauArchiver: 'Produit réseau archivé avec succès',
    produitLocationArchiver: 'Produit location archivé avec succès',
    produitDiversArchiver: 'Produit divers archivé avec succès',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique archivé avec succès',
    produitNumeriqueArchiver: 'Produit numérique archivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc archivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie archivé avec succès',
    produitAutreArchiver: 'Produit autre archivé avec succès',
    produitSalonArchiver: 'Produit salon archivé avec succès',
    produitSponsoringArchiver: 'Produit sponsoring / événementiel archivé avec succès',
    produitPresseArchiver: 'Produit presse archivé avec succès',
  },
  desarchivage: {
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitFaceArchiver: 'Produit face désarchivé avec succès',
    produitReseauArchiver: 'Produit réseau désarchivé avec succès',
    produitLocationArchiver: 'Produit location désarchivé avec succès',
    produitDiversArchiver: 'Produit divers désarchivé avec succès',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique désarchivé avec succès',
    produitNumeriqueArchiver: 'Produit numérique désarchivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc désarchivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie désarchivé avec succès',
  },
  actions: {
    filtre: 'Filtre',
    delete: 'Supprimer',
    search: 'Rechercher',
    searchFace: 'Rechercher une face parmi les faces associées',
    searchEcran: 'Rechercher',
    ajouterFace: 'Ajouter une face par sa référence',
    ajouterEcran: 'Ajouter un écran',
    associerProduit: 'Associer un produit',
    newProduitDivers: 'Ajouter un produit divers',
    ajoutFaceViaEcran: 'Ajouter des faces',
    ajoutDemandeLogistique: 'Ajouter une demande logistique',
    saveAndUpdateCommandeLine: 'Sauvegarder et modifier le libellé des lignes de commandes',
    desarchiver: 'Désarchiver',
    archiver: 'Archiver',
    edit: 'Modifier',
    addParution: 'Ajouter une parution',
    modifierDateFin: 'Modifier la date de fin',
    modifierDateDebut: 'Modifier la date de début',
    exportPlanningReseauxTemposLc: 'Edition planning réseaux tempos et LC',
  },
  popUpAddNewProduitDivers: {
    title: 'Ajouter un produit divers',
  },
  popUpChangeLibelleLigneCmd: {
    title: 'Etes-vous sûr de vouloir appliquer le changement de libellé sur les lignes de commandes ?',
  },
  type: {
    reseau: 'Réseau',
    face: 'Face',
    autre: 'Autre',
    salon: 'Salon',
    presse: 'Presse',
    sponsoring: 'Sponsoring / Événementiel',
    location: 'Location',
    divers: 'Divers',
    dispositif: 'Dispositif',
    numerique: 'Ecran numérique',
    locationNumerique: 'Location numérique',
    reseauNumerique: 'Réseau numérique',
    bothLocation: 'Location/Location numérique',
    reseauTempo: 'Réseau tempo',
    reseauLc: 'Réseau LC',
    reseauMairie: 'Réseau mairie',
    regroupementProduit: 'Regroupement produit',
    encart: 'Encart',
    prestation: 'Prestation',
    tlpe: 'Tlpe',
    honoraire: 'Honoraire',
    impressionAffiche: 'Impression affiche',
  },
  categorieOperation: {
    livraisonDeBien: 'Livraison de bien',
    fournitureDeService: 'Fourniture de service',
    default: 'NC.',
    both: 'Livraison de bien / Fourniture de service',
  },
  tab: {
    products: 'Produits',
    unavailable: 'Non commercialisable',
    dispositif: 'Dispositif',
  },
  button: {
    newProduct: 'Nouveau produit',
    ajouterProduit: 'Ajouter un produit',
    selectProduit: 'Sélectionner un produit',
  },
  productType: {
    title: 'Créer un nouveau produit',
    breadcrumb: 'Création produit',
    face: 'Face LC',
    reseauTempo: 'Réseau tempo',
    reseauLc: 'Réseau LC',
    location: 'Location papier',
    locationNumerique: 'Location numérique',
    various: 'Divers',
    dispositif: 'Dispositif',
    salon: 'Salon',
    autre: 'Autre',
    presse: 'Presse',
    sponsoring: 'Sponsoring / Événementiel',
    reseauNumerique: 'Réseau numérique',
    numerique: 'Ecran numérique',
    produitPapier: 'Produits papiers',
    produitAutreMedia: 'Produits autres médias',
    produitNumerique: 'Produits numériques',
    produitAutre: 'Produits autres',
    reseauMairie: 'Réseau mairie',
    achat: 'Achat',
    impressionAffiche: 'Impression affiche',
  },
  newProduct: {
    title: 'Créer un nouveau produit',
    dispositifSupport: 'Support',
    typeDispositif: 'Type de dispositif',
    isDoubleFace: 'Double face',
    materielType: 'Type de matériel',
    renouvelable: 'Renouvelable',
    tab: {
      product: 'Produit',
      caracteristique: 'Caractéristiques',
      caracteristiques: 'Caractéristiques',
      faces: 'Faces associées',
      products: 'Produits associés',
      ventes: 'Ventes',
      encarts: 'Encarts',
      dispo: 'Disponibilités',
      ecrans: 'Ecrans associés',
      affectation: 'Affectation',
      logistique: 'Logistique',
      regleFacturation: 'Règle facturation',
      regleCommission: 'Règle commission',
      objectifVente: 'Objectif vente',
      regleAchat: 'Règle d\'achat',
      produitConcessionnaire: 'Concessionnaire',
      cgv: 'C.G.V',
      prestations: 'Prestations',
      demandeInterventionType: 'Demande d\'intervention',
      livraisonTab: 'Livraison',
    },
    nbDiffusionMax: 'Nb de diffusion max / jour',
    category: {
      Lc: 'Réseau longue conservation',
      Tempo: 'Réseau temporaire',
      tournant: 'Réseau tournant',
      ecran: 'Réseau écran numerique',
    },
    comptabilite: {
      title: 'Comptabilité',
      compteAnalytique: {
        title: 'Compte analytique',
        search: 'Rechercher un compte analytique',
        add: 'Créer le compte analytique',
      },
      schemaComptable: {
        search: 'Rechercher un schéma comptable',
      },
    },
    editionDcf: {
      title: 'Edition devis/commandes/factures',
      categorieGroupeProduitDeductible: 'Catégorie groupe produit déductible des totaux',
    },
    produitAchatLie: {
      title: 'Produit achat / vente interne lié',
      produit: {
        title: 'Produit',
        titleDetail: 'Produit :',
        search: 'Rechercher un produit à lier',
      },
    },
    commentaireVente: 'Commentaire vente',
    proposableReseau: 'Proposable en réseau',
    proposableLc: 'Proposable en LC',
    faceMotifNonCom: 'Motif non commercialisation',
    logisticable: 'Pris en compte lors de la logistique d\'affichage',
    dureeBoucle: 'Durée d\'une boucle (sec)',
    dureeSpot: 'Durée d\'un spot (sec)',
    dureeEntreBoucle: 'Durée entre chaque boucle (sec)',
    informations: 'Informations',
    adresse: 'Adresse',
    outdoor: 'Outdoor',
    codePanneau: 'Code panneau',
    productReference: 'Référence du produit',
    secteur: 'Secteur(s)',
    productLabel: 'Libellé du produit',
    localisation: 'Localisation',
    angleVision: 'Angle de vision',
    azimut: 'Azimut',
    adressePersonalisee: 'Adresse personnalisée (ne sera jamais écrasée par le patrimoine)',
    enVenantDe: 'En venant de',
    enAllantVers: 'En allant vers',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    eclaire: 'Eclairé',
    formatPlaceholder: 'Choisir un format ...',
    city: 'Ville',
    codePostal: 'Code postal',
    pays: 'Pays',
    saturation: 'Saturation',
    saturationLabel: '1 boucle /',
    cityPlaceholder: 'Rechercher une ville ...',
    reseauType: 'Type de réseau',
    reseauTypePlaceholder: 'Choisir un type de réseau ...',
    reseauCategorie: 'Catégorie de réseau',
    reseauCategoriePlaceholder: 'Choisir une catégorie ...',
    confrere: 'Confrère',
    quantiteFacePrevu: 'Quantité de faces prévues',
    partageable: 'Réseau partageable',
    confrerePlaceholder: 'Choisir un confrère ...',
    prixUnitaire: 'Prix unit.',
    quantite: 'Quantité',
    produit: 'Produit',
    tva: 'TVA',
    tlpe: 'Tlpe',
    honoraire: 'Honoraire',
    commissionnable: 'Commissionnable',
    facesAssociees: 'Faces associées au réseau',
    ecransAssociees: 'Ecrans associés au réseau',
    produitsAssocies: 'Association de produit',
    produitSynchro: 'Produit synchronisé avec le patrimoine',
    controleDisponibilite: 'Contrôle sur la disponibilité',
    latitude: 'Latitude',
    longitude: 'Longitude',
    disposition: 'Disposition',
    popinSynchro: {
      titre: 'Synchronisation',
      texte1: 'Les produits provenant du module Patrimoine sont synchronisés avec le module Gestion Commerciale c’est pourquoi vous n’avez pas la possibilité de modifier le produit depuis ce module.',
      texte2: 'Pour cela, nous vous invitons à modifier les caractéristiques du produit depuis le module Patrimoine.',
      update: 'Modifier le produit',
    },
    seeEmplacement: 'Voir l’emplacement',
    emplacement: 'Emplacements',
    titleAccesRapide: 'Accès rapide',
    restrictionAffichage: {
      title: 'Restriction',
      restricitionAffichage: 'Restriction d\'affichage :',
      restricitionAffichageEdition: 'Restriction d\'affichage',
      noRestriction: 'Aucune restriction d\'affichage',
    },
    societe: 'Société',
    voirListeAffichage: 'Voir la liste d\'affichage',
    voirCommandes: 'Voir les commandes',
    voirFactures: 'Voir les factures',
    voirLignesCommande: 'Voir les lignes de commande',
    voirParutions: 'Voir les parutions',
    voirPlanMedia: 'Voir les plans média',
    voirBaux: 'Voir les baux',
    categorieOperation: 'Catégorie opération',
    infoMarche: 'Information du marché',
    stockable: 'Stockable',
  },
  editProduct: {
    title: 'Modifier produit {libelle}',
  },
  saturation: {
    full: 'Full (toutes les boucles)',
    access: 'Access (1 boucle sur 2)',
  },
  validation: {
    pourcentCouverture: '% de couverture',
    materielType: 'Type de matériel',
    dispositifType: 'Type de dispositif',
    materielFormat: 'Format',
    dispositifSupport: 'Support',
    repetition: 'Nb de répétition',
    commercial: 'Commercial',
    categoryRequired: 'Le champ "Catégorie de réseau" est obligatoire.',
    formatRequired: 'Le champ "Format" est obligatoire.',
    packProductWithBillboard: 'Un réseau ne doit pas contenir des informations relatives à une face.',
    encartSold: 'Impossible de modifier un encart vendu dans une commande ou un devis',
    startDateGreaterThanEndDate: 'La date de fin ne peut être antérieure à la date de début.',
    affectationStartDateGreaterThanEndDate: 'La date de fin d\'un produit associé ne peut être antérieure à la date de début.',
    onlyOneObjectifByCommercial: 'Il ne doit y avoir qu\'un seul objectif par commercial',
    dateCommercialOverlap: 'Il n\'est pas possible de mettre plusieurs commissions pour une même période pour le commercial : {commercial}',
    affectationReseauFaceDateOverlaping: 'Les dates d\'une même face associée ne peuvent se chevaucher.',
    regleAchatDateOverlap: 'Les dates des règles d\'achat ne peuvent pas se chevaucher ({dateDebut} - {dateFin})',
    GapBetweenBuyingRanges: 'Il y a un écart entre la tranche se terminant à {montantHaut} et celle débutant à {montantBas} ({dateDebut} - {dateFin})',
    trancheAchatShouldStartAt0: 'Les tranches d\'achat doivent commencer à 0. Début tranches : {montantBas} ({dateDebut} - {dateFin})',
    trancheAchatLowAmountGreaterHighAmount: 'Le montant bas ne peut être supérieur au montant haut ({dateDebut} - {dateFin}, tranche {montantBas} - {montantHaut})',
    amountTrancheOverlap: 'Le montant des tranches d\'achat doivent partir de zéro, se suivre et il ne doit pas y avoir d\'écart',
    affectationReseauFaceReseauDateOverlaping: 'La face ou l\'écran "{produit}" est associé(e) plusieurs fois sur les périodes : {periodes}',
    liaisonTarifDateOverlaping: 'Les dates du produit "{produit}" ne peuvent pas se chevaucher.',
    liaisonTarifSens: 'Le sens du produit associé "{libelleLiaison}" n\'est pas le même que celui du produit',
    dateDebut: 'Vous devez saisir une date de début.',
    dateFinBeforeDateDebut: 'La date de fin doit être supérieure à la date de début.',
    liaisonTarifDateFinBeforeDateDebut: 'La date de début de la liaison "{libelleLiaison}" ne doit pas être postérieure à la date de fin.',
    productLibelleEmpty: 'Le libellé du produit est obligatoire.',
    produitDiversTlpeEtHonoraire: 'Un produit divers ne peut pas être "Honoraire" et "TLPE"',
    updateProduitWithHolding: 'Interdit de créer ou de modifier un produit divers ou un produit de location sur une société autre que la holding',
    reseauMairieFaceCommercialisableNotAllowed: 'Dans un réseau mairie, les seules faces qui peuvent être associées doivent être des faces non commercialisables',
    reseauMairieOnlyDiversInLiaison: 'Dans un réseau mairie, on ne peut associer que des produits divers',
    regleFacturationRequired: 'La règle de facturation est obligatoire',
    regleCommission: {
      calculAvance: 'Le champ "Calcul sur" de la liste des règles de commission est obligatoire.',
      dateDebut: 'Date de debut de la liste des règles de commission',
      dateReference: 'Le champ  "Calcul à partir" de la liste des règles de commission est obligatoire.',
      aSignature: '% Signature de la liste des règles de commission',
      aEncaissement: '% Encaissement de la liste des règles de commission',
      passeParMandataire: '% Mandataire de la liste des règles de commission',
      aSignatureNvClient: '% Sig. nv client de la liste des règles de commission',
      aEncaissementNvClient: '% Encaissement nv client de la liste des règles de commission',
      commercial: 'Commercial de la liste des règles de commission',
    },
    cgv: {
      remise: 'Pourcentage de remise de la liste des C.G.V',
      libelleRemise: 'Libelle de remise de la liste des C.G.V',
    },
    encart: {
      noDeleteEncart: 'Impossible de supprimer l\'encart {reference} car il est vendu',
      tauxTva: 'Taux de TVA de la liste des encarts',
    },
    reglesAchat: {
      regimeTva: 'Régime de TVA de la liste des règles d\'achat',
      startDate: 'Date de début de la liste des règles d\'achat',
      pourcentageReversement: 'Pourcentage reversement de la liste des règles d\'achat',
      payoutAmountRequiredIfFixedAmount: 'Le montant du paiement est requis pour la règle d\'achat du {debut} au {fin} avec le type de montant fixe',
      payoutPercentageRequiredIfFixedPercentage: 'Le pourcentage de paiement est requis pour la règle d\'achat du {debut} au {fin} avec le type de pourcentage fixe',
      payoutPercentageRequiredIfGuaranteedRevenueSelected: 'Le pourcentage de paiement est obligatoire pour la règle d\'achat du {debut} au {fin} avec un chiffre d\'affaire garanti',
      onlyOneOfGuaranteedFieldsAllowed: 'Un seul champ "garanti" à la fois n\'est autorisé pour la règle d\'achat du {debut} au {fin}',
    },
    objectifsVente: {
      anne: 'Année de la liste des objectifs vente',
      commercial: 'Commercial de la liste des objectifs vente',
      montantHt: 'Montant HT de la liste des objectifs vente',
    },
    prestation: {
      tauxTva: 'Taux de TVA de la liste des prestations',
    },
    impossibleToArchiveProduitFaceLiePatrimoine: 'Impossible d\'archiver un produit face lié à un patrimoine',
    demandeTechnique: {
      typeOt: 'Type d\'ot',
      sujet: 'Sujet',
      ordreRealisation: 'Ordre',
      sujetListe: 'Le champ "Sujet" dans la liste des demandes techniques',
      typeOtListe: 'Le champ "Type d\'ot" dans liste des demandes techniques',
      ordreRealisationListe: 'Le champ "Ordre" dans la liste des demandes techniques',
    },
    referenceTooBig: 'La taille de la référence est trop grande pour l\'encart "{reference}"',
    faceMustBeFromSameCompanyAsTheNetworkProduct: 'La face {libelle} doit être de la même société que le produit réseau',
  },
  table: {
    audience: 'Audience / an',
    reference: 'Référence',
    type: 'Type',
    label: 'Libellé',
    outdoor: 'Outdoor',
    face: 'Face',
    ecran: 'Ecran',
    format: 'Format',
    materiel: 'Matériel',
    adresse: 'Adresse',
    ville: 'Ville',
    codePostal: 'Code postal',
    reseauFaceTags: 'Sous réseau',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    societe: 'Société',
    agence: 'Agence',
    enseignePrincipale: 'Enseigne principale',
    montantTlpe: 'TLPE (1 sem)',
    code: 'Code',
    actif: 'Archivé',
    listeAffichage: 'Liste d\'affichage',
    formatAffiche: 'Format d\'affiche',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    categorie: 'Liste des types de produits',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    societe: 'Societé',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    avecLiaisons: 'Avec produit(s) associé(s)',
    stockable: 'Stockable',
    renouvelable: 'Renouvelable',
  },
  addSuccess: 'Le produit a été créé avec succès',
  updateSuccess: 'Le produit a été modifié avec succès',
  aucunProduitAssocie: 'Aucun produit associé n\'est présent,',
  addProduitAssocie: 'Ajouter facilement vos produits associés en modifiant votre produit',
  number: 'N° {reference}',
  default: 'Produit par défaut :',
  defaultSelect: 'Sélectionner un produit par défaut',
  aucunDefaut: 'Aucun produit sélectionné',
  lat: 'Latitude',
  long: 'Longitude',
  couleur: 'Couleur',
  calculAutoTlpe: 'Calcul auto',
  tarifUnitaire: 'Tarif unitaire',
  info: {
    missingInfoForCalculAutoTypeTaxationTlpe: 'Attention, le type de taxation doit être renseigné sur {faceOrMateriel} pour faire le calcul automatique',
    missingInfoForCalculAutoSurfaceTlpe: 'Attention, la surface TLPE doit être renseignée sur {faceOrMateriel} pour faire le calcul automatique',
    isInRegroupementProduit: 'Le produit est dans le regroupement.',
    updateProductInRegroupement: 'Vous ne pouvez modifier ces informations que sur le produit regroupement',
    produitSynchro: 'Le produit est lié à un patrimoine',
    isNotModifiableIntoHolding: 'Le produit ne peut-être archivé sur une société autre que la holding',
  },
  faceMateriel: {
    face: 'la face',
    materiel: 'le matériel',
  },
  etatProduit: 'Produit archivé',
  popUpImportExcel: {
    titleObjectifReseauTempo: 'Importer les objectifs du réseau tempo',
    errorNoLineData: 'Aucune ligne de données dans le fichier importé',
    errorNoDataObjectif: 'Certains objectifs de semaine n\'ont pas été saisis',
    errorValueObjectif: 'Réseau: {libelle} - La valeur de l\'objectif est incorrecte pour la/les semaine(s) suivante(s): {semaines}',
    errorDispoObjectif: 'Réseau: {libelle} - Pas de disponibilité sur la/les semaine(s) suivante(s): {semaines}',
  },
  produitConcessionnaire: {
    title: 'Gestion concession',
    actions: {
      add: 'Ajouter une ligne de concession',
      searchBailleur: 'Chercher un bailleur',
    },
    tab: {
      bailleur: 'Bailleur',
      pourcentage: 'Pourcentage',
      noConcession: 'Aucune concession ajoutée',
      addConcessionDetail: 'Ajouter facilement vos concessions en modifiant votre produit',
    },
  },
  demandeInterventionType: {
    add: 'Ajouter une demande d\'intervention',
    tab: {
      sujet: 'Sujet',
      ordreRealisation: 'Ordre',
      typeDemande: 'Type demande',
      typeOt: 'Type d\'ot',
    },
    titlePopup: 'Etes-vous sûr de vouloir supprimer cette demande d\'intervention ?',
    deleteSuccess: 'Demande d\'intervention supprimée avec succès.',
    popUpAddEdit: {
      titleEdit: 'Modifier une demande d\'intervention',
      titleAdd: 'Ajouter une demande d\'intervention',

    },
  },
  popUpEditionPlanningReseauxTemposLc: {
    title: 'Edition planning réseau temporaire et réseau LC',
    dateReference: 'Date de référence',
    dateReferenceMsgRequired: 'La date de référence obligatoire',
    produitsMsgRequired: 'Veuillez sélectionner au moins un produit réseaux tempos ou réseaux LC',
  },
  popUpCheckFacesImpact: {
    title: 'Vérification des faces impactées',
    descriptionListeVente: 'Vous avez désaffecté du réseau les faces suivantes et cela a un impact sur vos ventes :',
    descriptionListeLogistique: 'Vous avez désaffecté du réseau les faces suivantes et cela a un impact sur la logistique :',
    typeModification: {
      suppression: 'Suppression',
      modification: 'Modification',
    },
    table: {
      reference: 'Face',
      format: 'Format',
      materiel: 'Matériel',
      adresse: 'Adresse',
      codePostal: 'Code postal',
      ville: 'Ville',
      dateDebutAff: 'Date de début',
      dateFinAff: 'Date de fin',
      typeModification: 'Type de modification',
    },
    vousSouhaitez: 'Vous souhaitez ?',
    action: {
      telechargerFichierExcelImpacts: 'Télécharger le fichier Excel des impacts',
      prevenirParEmailCommerciaux: 'Prévenir par email les commerciaux',
    },
  },
  formatsAffiche: {
    title: 'Formats d\'affiche',
    visuel: 'Visuel',
    impression: 'Impression',
    faconnage: 'Façonnage',
    expedition: 'Expédition',
    facesAdded: 'Faces(s) ajoutée(s)',
    noFormatsAfficheInProduit: 'Aucun format d\'affiche n\'a été personnalisé pour ce réseau',
    aNewFormatAfficheIsAddInFaceProduit: 'Vous avez ajouté une ou plusieurs face(s) dont le format d\'affiche est personnalisé pour ce réseau. Voulez-vous vérifier l\'onglet livraison avant de sauvegarder ?',
    recap: {
      title: 'Récapitulatif des formats d\'affiche',
      formatAffiche: 'Format d\'affiche',
      quantite: 'Quantité',
    },
  },
};

export const DETAIL_PRODUIT_RESEAU = {
  titleTempo: 'Détail réseau tempo {libelle}',
  breadcrumbTempo: 'Détail réseau tempo {libelle}',
  titleLc: 'Détail réseau LC {libelle}',
  breadcrumbLc: 'Détail réseau LC {libelle}',
  logisticable: 'Pris en compte dans la logistique : ',
  partageable: 'Réseau partageable : ',
  renouvelable: 'Renouvelable : ',
  onglet: {
    product: 'Produit',
    face: 'Faces associées',
    productAssocie: 'Produits associés',
  },
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitReseauArchiver: 'Produit réseau archivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc archivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitReseauArchiver: 'Produit réseau désarchivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc désarchivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie désarchivé avec succès',
  },
  facesAssociesReseau: 'Faces associées au réseau',
  facesAssociesReseauMessage: 'Le nombre de faces associées ne définit pas la disponibilité',
  infoFacesAssociesReseau: 'Information',
  categorie: 'Catégorie de réseau :',
  type: 'Type de réseau :',
  format: 'Format :',
  agence: 'Agence :',
  dateDebut: 'Date de début :',
  dateFin: 'Date de fin :',
  city: 'Ville :',
  facesDispo: 'Nb faces réelles au {date}: ',
  nbFacePrevu: 'Nb faces prévues :',
  quantiteFacePrevue: 'Quantité de faces prévues : ',
  tarif: 'Prix :',
  secteur: 'Secteur(s):',
  nonDefini: 'Non défini',
  pasFace: 'Pas de face associée',
  to: 'Au',
  popUpInfoTlpe: {
    title: 'Information tlpe de la face {face}',
    avertissements: {
      title: 'Avertissement',
      noLineForMaterielAndYearWithRemplacement: 'Aucune ligne de taxation tlpe n\'existe à l\'année {anneeBase}. La valeur de l\'année {anneeRemplacement} a été utilisée à la place',
    },
    errors: {
      title: 'Impossible d\'obtenir la TLPE par semaine',
      shouldBeLinkedToFace: 'Le produit face n\'est pas lié à une face patrimoniale',
      shouldHaveSurface: 'Le matériel lié à la face patrimoniale doit avoir une surface',
      noLineForMateriel: 'Aucune ligne de taxation tlpe n\'existe à l\'année {anneeBase}',
    },
  },
  libelleProduitTempoForLogo: 'Produit réseau temporaire {ref}',
  libelleProduitLcForLogo: 'Produit réseau lc {ref}',
  societe: 'Société :',
  warnings: {
    secteurs: 'Secteur(s) archivé(s) : {secteurs}',
  },
};

export const SUPPRESSION_PRODUIT_RESEAU = {
  suppression: {
    supprimer: 'Etes-vous sûr de vouloir supprimer ce produit ?',
    successDelete: 'Produit supprimé avec succès',
  },
  validation: {
    noDeleteReseauUsedInSale: 'Ce réseau est utilisé dans {recurrence} vente(s)',
    noDeleteReseauUsedInLogisticRequest: 'Ce réseau est utilisé dans {recurrence} demande(s) logistique(s)',
    noDeleteReseauUsedInTFS: 'Ce réseau est utilisé en logistique dans {recurrence} semaine(s)',
  },
};

export const DETAIL_PRODUIT_RESEAU_NUMERIQUE = {
  title: 'Détail réseau numérique {libelle}',
  breadcrumb: 'Détail réseau numérique {libelle}',
  onglet: {
    product: 'Produit',
    face: 'Ecrans associés',
    productAssocie: 'Produits associés',
  },
  ecransAssociesReseau: 'Ecrans associés au réseau',
  categorie: 'Catégorie de réseau :',
  type: 'Type de réseau :',
  format: 'Format :',
  agence: 'Agence :',
  dateDebut: 'Date de début :',
  dateFin: 'Date de fin :',
  nbDiffusionMax: 'Nb diffusion max / jour :',
  city: 'Ville :',
  ecransDispo: 'Ecrans disponibles : ',
  tarif: 'Prix :',
  nonDefini: 'Non défini',
  dureeSpot: 'Durée d\'un spot :',
  dureeBoucle: 'Durée d\'une boucle :',
  societe: 'Société :',
  renouvelable: 'Renouvelable :',
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique désarchivé avec succès',
  },
  libelleProduitForLogo: 'Produit réseau numérique {ref}',
};

export const PRODUIT_LOCATION = {
  title: 'Détail location {libelle}',
  titleNumerique: 'Détail location numérique {libelle}',
  tva: 'TVA:',
  prixUnitaire: 'Prix unitaire:',
  numero: 'N° ',
  quantites: 'Quantité:',
  produit: 'Produit',
  produitAssocie: 'Produits associés',
  pourcentage: '%',
  saturation: 'Saturation :',
  saturationLabel: '1 boucle /',
  agence: 'Agence :',
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitLocationArchiver: 'Produit location archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitLocationArchiver: 'Produit location désarchivé avec succès',
  },
  libelleProduitForLogo: 'Produit location {ref}',
  libelleProduitLocNumeriqueForLogo: 'Produit location numérique {ref}',
  societe: 'Société :',
  categorieOperation: 'Catégorie opération :',
};

export const PRODUIT_DIVERS = {
  title: 'Détail divers {libelle}',
  tva: 'TVA:',
  prixUnitaire: 'Prix unitaire:',
  numero: 'N° ',
  quantites: 'Quantité:',
  agence: 'Agence :',
  tlpe: 'Tlpe:',
  honoraire: 'Honoraire:',
  commissionnable: 'Commissionnable:',
  produit: 'Produit',
  pourcentage: '%',
  renouvelable: 'Renouvelable:',
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitDiversArchiver: 'Produit divers archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitDiversArchiver: 'Produit divers désarchivé avec succès',
  },
  libelleProduitForLogo: 'Produit divers {ref}',
  societe: 'Société :',
  categorieOperation: 'Catégorie opération :',
  stockable: 'Stockable :',
};

export const PRODUIT_DISPOSITIF = {
  title: 'Détail dispositif {libelle}',
  tva: 'TVA:',
  prixUnitaire: 'Prix unitaire:',
  numero: 'N° ',
  quantites: 'Quantité:',
  agence: 'Agence :',
  doubleFace: 'Double face :',
  eclaire: 'Eclairé :',
  honoraire: 'Honoraire:',
  commissionnable: 'Commissionnable:',
  produit: 'Produit',
  pourcentage: '%',
  dispositifType: 'Type de dispositif',
  dispositifSupport: 'Support',
  materielType: 'Type de matériel',
  materielFormat: 'Format du matériel',
  renouvelable: 'Renouvelable :',
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitDispositifArchiver: 'Produit dispositif archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitDispositifArchiver: 'Produit dispositif désarchivé avec succès',
  },
  libelleProduitForLogo: 'Produit dispositif {ref}',
  societe: 'Société :',
};

export const PRODUIT_FACE = {
  onglet: {
    produit: 'Produit',
    productAssocie: 'Produits associés',
    affectation: 'Affectations',
  },
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitFaceArchiver: 'Produit face archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitFaceArchiver: 'Produit face désarchivé avec succès',
  },
  actions: {
    search: 'Rechercher',
  },
  affectation: {
    nbResultat: '{nb} résultat(s)',
    duAu: 'Du {debut} au {fin}',
    duAuWeek: 'Du {debut} au {fin}, semaine {week} de {year}',
    viewReseau: 'Voir le réseau',
    viewCommande: 'Voir la commande',
    montantLoc: 'Prix location : ',
    montantFace: 'Prix par face : ',
    surfaceVendue: 'Pourcentage de surface : ',
  },
  catalogue: 'Catalogue',
  title: 'Détail face LC {libelle}',
  codePanneau: 'Code panneau :',
  format: 'Format :',
  adresseCommercial: 'Adresse commerciale :',
  faceMotifNonCom: 'Motif non commercialisation :',
  proposableReseau: 'Proposable en réseau :',
  proposableLc: 'Proposable en LC :',
  azimut: 'Azimut :',
  materiel: 'Matériel :',
  departement: 'Département :',
  angleVision: 'Angle de vision :',
  support: 'Support :',
  agence: 'Agence :',
  secteur: 'Secteur(s)',
  aglomeration: 'Agglomération :',
  enVenantDe: 'En venant de :',
  enAllantVers: 'En allant vers :',
  eclaire: 'Eclairé :',
  localisation: 'Localisation :',
  tarif: 'Prix :',
  nonDefini: 'Non défini',
  libelleProduitForLogo: 'Produit face {ref}',
  societe: 'Société :',
  latitude: 'Latitude :',
  longitude: 'Longitude :',
  renouvelable: 'Renouvelable',
  otTechnique: {
    title: 'Ordre de travail technique',
  },
  disposition: 'Disposition :',
  warnings: {
    secteurs: 'Secteur(s) archivé(s) : {secteurs}',
  },
};

export const SPONSORING = {
  title: 'Détail produit sponsoring / événementiel : {libelle}',
};

export const PRESSE = {
  title: 'Détail produit presse : {libelle}',
  periodicite: 'Périodicité :',
  prestationGracieuse: {
    title: 'Prestations gracieuses',
    field: 'Prestations gracieuses :',
  },
  formatProduit: {
    title: 'Format du produit :',
    largeurPleinPapier: 'Largeur plein papier (mm) :',
    hauteurPleinPapier: 'Hauteur plein papier (mm) :',
    largeurFormatUtile: 'Largeur format utile (mm) :',
    hauteurFormatUtile: 'Hauteur format utile (mm) :',
    margeHaut: 'Marge haut (mm) :',
    margeGauche: 'Marge gauche (mm) :',
    periodicite: 'Périodicité (mm) :',
    typeFormatPresse: 'Type de format (mm) :',
  },
  modeDistribution: 'Mode de distribution :',
  nbrTirage: 'Nombre de tirage :',
  controleDisponibilite: 'Contrôle sur la disponibilité',
  renouvelable: 'Renouvelable :',
};

export const SALON = {
  title: 'Détail produit salon : {libelle}',
  caracteristique: {
    code: 'Code :',
    libelle: 'Libellé :',
    agence: 'Agence :',
    typeProduit: 'Type de produit :',
    assistant: 'Assistant(e) :',
  },
  marche: {
    title: 'Information du marché',
    field: 'Marché',
  },
  regleFacturation: {
    title: 'Règle de facturation',
    field: 'Règle de facturation :',
  },
  dates: {
    titre: 'Dates',
    dateDebut: 'Date de debut :',
    dateFin: 'Date de fin :',
    dateSignature: 'Date de signature :',
  },
  commentaire: {
    title: 'Commentaire',
    field: 'Commentaire :',
  },
};

export const AUTRE = {
  title: 'Détail produit autre : {libelle}',
};

export const ECRAN_NUMERIQUE = {
  title: 'Détail écran numérique {libelle}',
  ecran: 'Ecran numérique {libelle}',
  onglet: {
    produit: 'Produit',
    productAssocie: 'Produits associés',
    disponibilites: 'Disponibilités',
  },
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitNumeriqueArchiver: 'Produit numérique archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitNumeriqueArchiver: 'Produit numérique désarchivé avec succès',
  },
  renouvelable: 'Renouvelable :',
  codePanneau: 'Code panneau :',
  dureeSpot: 'Durée d\'un spot :',
  adresseCommercial: 'Adresse commerciale :',
  azimut: 'Azimut :',
  outdoor: 'Outdoor :',
  oui: 'Oui',
  non: 'Non',
  dureeBoucle: 'Durée d\'une boucle :',
  departement: 'Département :',
  angleVision: 'Angle de vision :',
  format: 'Format :',
  aglomeration: 'Agglomération :',
  enVenantDe: 'En venant de :',
  enAllantVers: 'En allant vers :',
  localisation: 'Localisation :',
  materiel: 'Matériel :',
  support: 'Support :',
  tarif: 'Prix :',
  nonDefini: 'Non défini',
  libelleProduitForLogo: 'Produit écran numérique {ref}',
  societe: 'Société :',
};

export const DETAIL_CATALOGUE = {
  comptabilite: {
    title: 'Comptabilité',
    compteAnalytique: {
      title: 'Compte analytique :',
    },
  },
  produitAchatLie: {
    title: 'Produit achat / vente interne lié',
    produit: {
      titleDetail: 'Produit :',
    },
  },
  editionDcf: {
    title: 'Edition devis/commandes/factures',
    categorieGroupeProduitDeductible: 'Catégorie groupe produit déductible des totaux :',
  },
  dispositif: 'Dispositif',
  commentaireVente: {
    title: 'Commentaire vente',
  },
};

export const SELECTION_PRODUITS = {
  title: 'Ma sélection',
  sousTitle: '{nbrProduit} produits dans votre sélection',
  panierVide: 'Votre sélection est vide',
  noFace: 'Sélectionnez des faces',
  noProduit: 'Sélectionnez des produits',
  datePeriode: 'Du {dateDebut} au {dateFin}',
  noNewFace: 'Aucune face ajouté via l\'écran de sélection',
  noNewProduit: 'Aucun produit ajouté via l\'écran de sélection',
  produitFromReseau: 'Face(s) présente(s) dans le réseau',
  produitFromSelection: 'Produit(s) ajoutée(s) via l\'écran de sélection',
  newSelection: 'Nouvelle sélection',
  clearSelection: 'Vider ma sélection',
};
